// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: ?string,
}

const IconExpand = ({ className }: PropsT) => (
  <svg className={classnames('Icon IconWarningError', className)} viewBox='0 0 88 74' xmlns='http://www.w3.org/2000/svg'>
    <title>error/warning icon</title>
    <defs />
    <g id='Flexible-Metadata-Phase-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='supplier-portal-home---error-loading-studies' transform='translate(-676.000000, -288.000000)'>
        <g id='error/warning-icon' transform='translate(674.000000, 285.000000)'>
          <path d='M40.7680005,8.53043399 C43.657554,3.81920539 48.3443878,3.82237136 51.2319995,8.53043399 L86.7680005,66.469566 C89.657554,71.1807946 87.5315577,75 82.0012136,75 L9.99878636,75 C4.47660914,75 2.34438777,71.1776286 5.23199951,66.469566 L40.7680005,8.53043399 Z' id='Triangle' stroke='#F65454' strokeWidth='3' />
          <path d='M49.2971121,52.6231029 L49.2971121,52.6231029 C48.276103,52.2209162 47.1638503,52 46,52 C44.8361497,52 43.723897,52.2209162 42.7028879,52.6231029 L40.1860471,32.4883768 C40.0645735,32.0124486 40,31.5137653 40,31 C40,27.6862915 42.6862915,25 46,25 C49.3137085,25 52,27.6862915 52,31 C52,31.5137653 51.9354265,32.0124486 51.8139529,32.4883768 L49.2971121,52.6231029 Z M46,67 C42.6862915,67 40,64.3137085 40,61 C40,57.6862915 42.6862915,55 46,55 C49.3137085,55 52,57.6862915 52,61 C52,64.3137085 49.3137085,67 46,67 Z' id='exlaimation-point' fill='#F65454' />
        </g>
      </g>
    </g>
  </svg>
)

export default IconExpand
